(function() {
  'use strict';

  var script = document.currentScript;
  var config = {
    flagEn: script && script.getAttribute('data-flag-en') || '',
    flagIt: script && script.getAttribute('data-flag-it') || '',
    finishNormal: script && script.getAttribute('data-finish-normal') || 'Normal',
    finishFoil: script && script.getAttribute('data-finish-foil') || 'Foil',
    labelVersion: script && script.getAttribute('data-label-version') || 'Version',
    labelLanguage: script && script.getAttribute('data-label-language') || 'Language',
    labelCondition: script && script.getAttribute('data-label-condition') || 'Condition'
  };
  var singleTypes = [
    'magic single',
    'yugioh single',
    'one piece single',
    'dragon ball super singles',
    'pokémon single',
    'digimon single',
    'flesh and blood single'
  ];
  var wishlistRequests = new Map();

  function normalize(value) {
    return String(value == null ? '' : value).trim().toLowerCase();
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function isSingleType(productType) {
    return singleTypes.indexOf(normalize(productType)) !== -1;
  }

  function optionNames(product) {
    return (product && Array.isArray(product.options) ? product.options : []).map(function(option) {
      return typeof option === 'string' ? option : option && (option.name || option.title) || '';
    });
  }

  function variantValues(variant) {
    if (!variant) return [];
    if (Array.isArray(variant.options)) return variant.options;
    var directValues = [variant.option1, variant.option2, variant.option3].filter(function(value) {
      return value !== null && value !== undefined;
    });
    if (directValues.length) return directValues;
    if (!variant.title || variant.title === 'Default Title') return [];
    return String(variant.title).split(/\s+(?:\/|·)\s+/).filter(Boolean);
  }

  function inferredOptionName(value) {
    var key = normalize(value);
    if (languageMeta(value)[0] && [
      'english', 'inglese', 'italian', 'italiano', 'german', 'tedesco',
      'french', 'francese', 'spanish', 'spagnolo', 'japanese', 'giapponese',
      'portuguese', 'portoghese', 'korean', 'coreano', 'chinese', 'cinese',
      'russian', 'russo', 'en', 'it', 'de', 'fr', 'es', 'jp', 'pt', 'kr', 'cn', 'ru'
    ].indexOf(key) !== -1) return 'Language';
    if (key === 'mint' || key === 'm' || key === 'nm' || key === 'ex' || key === 'lp' || key === 'good' || key === 'gd' || key === 'played' || key === 'pl' || key === 'poor' || key === 'po' || key.indexOf('near mint') !== -1 || key.indexOf('excellent') !== -1 || key.indexOf('lightly played') !== -1 || key.indexOf('light played') !== -1 || key.indexOf('damaged') !== -1 || key.indexOf('danneggiat') !== -1) return 'Condition';
    if (key.indexOf('foil') !== -1 || ['normal', 'normale', 'regular'].indexOf(key) !== -1) return 'Version';
    return '';
  }

  function languageMeta(value) {
    var key = normalize(value);
    var values = {
      english: ['EN', config.flagEn, ''], inglese: ['EN', config.flagEn, ''], en: ['EN', config.flagEn, ''],
      italian: ['IT', config.flagIt, ''], italiano: ['IT', config.flagIt, ''], it: ['IT', config.flagIt, ''],
      german: ['DE', '', '🇩🇪'], tedesco: ['DE', '', '🇩🇪'], de: ['DE', '', '🇩🇪'],
      french: ['FR', '', '🇫🇷'], francese: ['FR', '', '🇫🇷'], fr: ['FR', '', '🇫🇷'],
      spanish: ['ES', '', '🇪🇸'], spagnolo: ['ES', '', '🇪🇸'], es: ['ES', '', '🇪🇸'],
      japanese: ['JP', '', '🇯🇵'], giapponese: ['JP', '', '🇯🇵'], jp: ['JP', '', '🇯🇵'],
      portuguese: ['PT', '', '🇵🇹'], portoghese: ['PT', '', '🇵🇹'], pt: ['PT', '', '🇵🇹'],
      korean: ['KR', '', '🇰🇷'], coreano: ['KR', '', '🇰🇷'], kr: ['KR', '', '🇰🇷'],
      chinese: ['CN', '', '🇨🇳'], cinese: ['CN', '', '🇨🇳'], cn: ['CN', '', '🇨🇳'],
      russian: ['RU', '', '🇷🇺'], russo: ['RU', '', '🇷🇺'], ru: ['RU', '', '🇷🇺']
    };
    var fallback = String(value || '').slice(0, 2).toUpperCase();
    return values[key] || [fallback, '', ''];
  }

  function conditionCode(value) {
    var key = normalize(value);
    if (key.indexOf('near mint') !== -1 || key === 'nm') return 'NM';
    if (key === 'mint' || key === 'm') return 'M';
    if (key.indexOf('excellent') !== -1 || key === 'ex') return 'EX';
    if (key.indexOf('lightly played') !== -1 || key.indexOf('light played') !== -1 || key === 'lp') return 'LP';
    if (key === 'good' || key === 'gd') return 'GD';
    if (key === 'played' || key === 'pl') return 'PL';
    if (key === 'poor' || key === 'po') return 'PO';
    if (key.indexOf('damaged') !== -1 || key.indexOf('danneggiat') !== -1) return 'DMG';
    return String(value || '').toUpperCase();
  }

  function badge(className, label, content) {
    return '<span class="enigma-single-card-variant-viewer__badge ' + className + '" aria-label="' + escapeHtml(label) + '">' + content + '</span>';
  }

  function render(productType, names, variant, context) {
    if (!isSingleType(productType) || !variant) return '';
    var values = variantValues(variant);
    var finish = '';
    var language = '';
    var condition = '';
    var extras = [];

    (Array.isArray(names) ? names : []).forEach(function(name, index) {
      var key = normalize(name);
      var value = String(values[index] == null ? '' : values[index]).trim();
      if (!value) return;
      if (key === 'language' || key === 'lingua') language = value;
      else if (key === 'condition' || key === 'condizione') condition = value;
      else if (['edition', 'edizione', 'finish', 'finitura', 'foil', 'version', 'versione'].indexOf(key) !== -1) finish = value;
      else extras.push({ name: name, value: value });
    });

    var html = '';
    if (finish) {
      var finishKey = normalize(finish);
      var nonFoil = finishKey.indexOf('nonfoil') !== -1 || finishKey.indexOf('non-foil') !== -1 || finishKey.indexOf('non foil') !== -1 || ['normal', 'normale', 'regular'].indexOf(finishKey) !== -1;
      var foil = !nonFoil && finishKey.indexOf('foil') !== -1;
      var finishText = foil ? config.finishFoil : (nonFoil ? config.finishNormal : finish);
      var finishCompact = normalize(productType) === 'yugioh single' && /^(?:1st|first)[ -]edition$/.test(finishKey) ? '1ST' : finishText;
      var finishClass = foil ? ' is-foil' : (nonFoil ? ' is-normal' : '');
      var finishContent = foil
        ? '<span class="enigma-single-card-variant-viewer__star" aria-hidden="true">★</span>'
        : (nonFoil
          ? '<span class="enigma-single-card-variant-viewer__star is-normal" aria-hidden="true">☆</span>'
          : '<span>' + escapeHtml(finishCompact) + '</span>');
      html += badge('enigma-single-card-variant-viewer__finish' + finishClass, config.labelVersion + ': ' + finishText, finishContent);
    }
    if (language) {
      var languageData = languageMeta(language);
      var flag = languageData[1]
        ? '<img class="enigma-language-selector__flag" src="' + escapeHtml(languageData[1]) + '" alt="" width="20" height="14" aria-hidden="true">'
        : (languageData[2]
          ? '<span class="enigma-single-card-variant-viewer__flag-emoji">' + languageData[2] + '</span>'
          : '<span class="enigma-single-card-variant-viewer__flag-fallback">' + escapeHtml(languageData[0]) + '</span>');
      html += badge('enigma-single-card-variant-viewer__language', config.labelLanguage + ': ' + language, '<span class="enigma-single-card-variant-viewer__flag" aria-hidden="true">' + flag + '</span>');
    }
    if (condition) {
      html += badge('enigma-single-card-variant-viewer__condition', config.labelCondition + ': ' + condition, '<span aria-hidden="true">' + escapeHtml(conditionCode(condition)) + '</span>');
    }
    extras.forEach(function(extra) {
      html += badge('enigma-single-card-variant-viewer__extra', extra.name + ': ' + extra.value, escapeHtml(extra.value));
    });
    if (!html && variant.title && variant.title !== 'Default Title') {
      html = badge('enigma-single-card-variant-viewer__extra', variant.title, escapeHtml(variant.title));
    }
    if (!html) return '';

    var safeContext = normalize(context || 'dynamic').replace(/[^a-z0-9-]+/g, '-');
    return '<span class="enigma-single-card-variant-viewer enigma-single-card-variant-viewer--' + safeContext + '" data-enigma-single-card-variant-viewer data-product-type="' + escapeHtml(productType) + '" data-option-names="' + escapeHtml(JSON.stringify(names || [])) + '" data-variant-id="' + escapeHtml(variant.id || '') + '" data-viewer-context="' + safeContext + '">' + html + '</span>';
  }

  function preferredVariant(product) {
    var variants = product && Array.isArray(product.variants) ? product.variants : [];
    return variants.find(function(variant) { return variant.available; }) || variants[0] || null;
  }

  function renderProduct(product, context) {
    if (!product) return '';
    var variant = preferredVariant(product);
    var names = optionNames(product);
    var values = variantValues(variant);
    if (!names.length && values.length) {
      names = values.map(inferredOptionName);
      variant = Object.assign({}, variant, { options: values });
    }
    return render(product.type || product.product_type, names, variant, context || 'card');
  }

  function replaceViewer(viewer, html) {
    if (!viewer || !html) return;
    var holder = document.createElement('div');
    holder.innerHTML = html;
    var replacement = holder.firstElementChild;
    if (!replacement) return;
    replacement.className = viewer.className;
    viewer.replaceWith(replacement);
  }

  function productDataForScope(scope, viewer) {
    var jsonNode = scope.querySelector('[data-enigma-single-card-product-json]');
    if (jsonNode) {
      try { return JSON.parse(jsonNode.textContent); } catch (error) { return null; }
    }
    var raw = scope.getAttribute('data-json-product');
    if (!raw) return null;
    try {
      var data = JSON.parse(raw);
      data.type = viewer.getAttribute('data-product-type') || data.type;
      data.options = JSON.parse(viewer.getAttribute('data-option-names') || '[]');
      return data;
    } catch (error) {
      return null;
    }
  }

  function syncScope(scope) {
    if (!scope || !scope.querySelector) return;
    var viewer = scope.querySelector('[data-enigma-single-card-variant-viewer]');
    if (!viewer) return;
    var product = productDataForScope(scope, viewer);
    if (!product || !Array.isArray(product.variants)) return;
    var idInput = scope.querySelector('[data-variant-id-input], input[name="id"], select[name="id"]');
    var selectedId = idInput && String(idInput.value);
    var selected = product.variants.find(function(variant) { return String(variant.id) === selectedId; }) || preferredVariant(product);
    var html = render(product.type || viewer.getAttribute('data-product-type'), optionNames(product), selected, viewer.getAttribute('data-viewer-context') || 'dynamic');
    replaceViewer(viewer, html);
  }

  function localizePath(path) {
    return window.EnigmaLocale && typeof window.EnigmaLocale.localizePath === 'function' ? window.EnigmaLocale.localizePath(path) : path;
  }

  function enhanceWishlist(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.wishlist-page .item-product[data-product-id^="product-"]').forEach(function(item) {
      if (item.querySelector('[data-enigma-single-card-variant-viewer]') || item.getAttribute('data-enigma-viewer-state')) return;
      var handle = String(item.getAttribute('data-product-id') || '').replace(/^product-/, '');
      if (!handle) return;
      item.setAttribute('data-enigma-viewer-state', 'loading');
      var request = wishlistRequests.get(handle);
      if (!request) {
        request = fetch(localizePath('/products/' + encodeURIComponent(handle) + '.js'), { credentials: 'same-origin', headers: { 'Accept': 'application/json' } }).then(function(response) {
          if (!response.ok) throw new Error(response.statusText);
          return response.json();
        });
        wishlistRequests.set(handle, request);
      }
      request.then(function(product) {
        var html = renderProduct(product, 'wishlist');
        if (html) {
          var title = item.querySelector('.product__title');
          if (title) title.insertAdjacentHTML('afterend', html);
        }
        item.setAttribute('data-enigma-viewer-state', 'ready');
      }).catch(function() {
        item.setAttribute('data-enigma-viewer-state', 'failed');
      });
    });
  }

  window.EnigmaSingleCardVariantViewer = {
    isSingleType: isSingleType,
    render: render,
    renderProduct: renderProduct,
    syncScope: syncScope
  };

  document.addEventListener('change', function(event) {
    var scope = event.target.closest('.item-product, .product-template__container');
    if (!scope || !scope.querySelector('[data-enigma-single-card-variant-viewer]')) return;
    window.setTimeout(function() { syncScope(scope); }, 0);
  }, true);

  function start() {
    enhanceWishlist(document);
    if (!window.MutationObserver) return;
    new MutationObserver(function(mutations) {
      var scopes = new Set();
      mutations.forEach(function(mutation) {
        Array.prototype.forEach.call(mutation.addedNodes, function(node) {
          if (node.nodeType !== 1) return;
          if (!node.closest('.wishlist-page') && !node.querySelector('.wishlist-page')) return;
          scopes.add(node.parentNode || node);
        });
      });
      scopes.forEach(enhanceWishlist);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
